import React from "react";
import {
  Stepper,
  Step,
  StepIndicator,
  Box,
  StepSeparator,
  Text,
} from "@chakra-ui/react";

export const steps = [
  { title: "Resultado" },
  { title: "Dados Pessoais" },
  { title: "Endereço" },
  { title: "Informações Bancárias" },
  { title: "Confirmação" },
];

interface ProposalFormStepperProps {
  activeStep: number;
  onStepClick?: (step: number) => void;
}

export default function ProposalFormStepper({
  activeStep,
  onStepClick,
}: ProposalFormStepperProps) {
  const handleKeyPress = (
    event: React.KeyboardEvent<HTMLDivElement>,
    step: number
  ) => {
    if (event.key === "Enter" || event.key === " ") {
      if (onStepClick) {
        onStepClick(step);
      }
    }
  };

  return (
    <Stepper
      index={activeStep}
      size="lg"
      mb={4}
      colorScheme="primary"
      gap={4}
      flexWrap="wrap"
      width="100%"
      orientation="horizontal"
    >
      {steps.map((step, index) => (
        <Step key={index}>
          <StepIndicator
            w={3}
            h={3}
            bg={index === activeStep ? "primary" : "transparent"}
            borderColor={index <= activeStep ? "green.500" : "green.300"}
            cursor={index <= activeStep ? "pointer" : "default"}
            onClick={() => {
              if (onStepClick && index <= activeStep) {
                onStepClick(index);
              }
            }}
            tabIndex={index <= activeStep ? 0 : -1}
            onKeyUp={(event) => {
              if (index <= activeStep && onStepClick) {
                handleKeyPress(event, index);
              }
            }}
            role={index <= activeStep ? "button" : undefined}
            aria-current={index === activeStep ? "step" : undefined}
            _hover={
              index <= activeStep
                ? {
                    bg: "primary",
                    transform: "scale(1.1)",
                    transition: "all 0.2s ease-in-out",
                  }
                : {}
            }
          />
          <Box
            onClick={() => {
              if (onStepClick && index <= activeStep) {
                onStepClick(index);
              }
            }}
            onKeyUp={(event) => {
              if (index <= activeStep && onStepClick) {
                handleKeyPress(event, index);
              }
            }}
            cursor={index <= activeStep ? "pointer" : "default"}
            tabIndex={index <= activeStep ? 0 : -1}
            _hover={
              index <= activeStep
                ? {
                    color: "secondary",
                    transform: "scale(1.05)",
                    transition: "all 0.2s ease-in-out",
                  }
                : {}
            }
            role={index <= activeStep ? "button" : undefined}
          >
            <Text fontSize="sm" fontWeight="medium">
              {step.title}
            </Text>
          </Box>
          <StepSeparator />
        </Step>
      ))}
    </Stepper>
  );
}
